import * as React from "react";
import {cx} from "emotion";
import {cs} from "@Common/react/chain-services";

import {SubscribeButton} from "../subscribe-button/subscribe-button";
import "./subscriptions-details-desktop.scss";
import {SubscribeCard} from "./subscribe-card/subscribe-card";

export const SubscriptionsDetailsDesktop = ({selectedPlanId, subscriptionPlans, subscriptionModal}) => cs(
    ({}) => (
        <div className="subscriptions-details-desktop-84e">
            <div className="top" style={{backgroundImage: `url(${require("../images/background.svg")})`}}>
                <div className="heading" xd-qa-type="label" xd-qa-name="Introducing">
                    Introducing
                    <div className="logo" xd-qa-type="logo" xd-qa-name="XD Logo">
                        <img alt="XD+" src={require("../images/xdplus-logo-white.svg")}/>
                    </div>
                </div>
                <div className="yellow-square"/>
                <div className="sub-heading-1" xd-qa-type="label" xd-qa-name="subheading">
                    <div className="white-square-1"/>
                    <div className="text" xd-qa-type="label" xd-qa-name="Subscribe to receive exclusive benefits and instant savings!">
                        Subscribe to receive exclusive benefits and instant savings!
                    </div>
                    <div className="white-square-2"/>
                </div>
                <div className="blue-square"/>
            </div>
            <div className="bottom">
                <div className="plans">
                    <div className="left">
                        {subscriptionPlans.value && subscriptionPlans.value.availableBenefits.map((benefit, index) =>
                            // TODO: remove bandaid solution to keep AI-assisted Property Descriptions from showing up in the benefits list
                            benefit !== "AI-assisted Property Descriptions" &&
                            <div key={index} className={cx("benefit", {odd: index % 2 === 1})}>{benefit}</div>
                        )}
                        <div className="logo">
                            <img alt="XD+" className="xd-plus-image" src={require("../../customize/steps/common/xd-plus-logo.png")}/>
                        </div>
                    </div>
                    {subscriptionPlans.value && subscriptionPlans.value.pricePoints.map((plan) => (
                        <React.Fragment key={plan.idChargebeePricePoint}>
                            {SubscribeCard({plan, selectedPlanId, subscriptionPlans})}
                        </React.Fragment>
                    )
                    )}
                </div>
                {SubscribeButton({subscriptionModal, planId: selectedPlanId.value})}
            </div>
        </div>

    ),
);
